//#region src/starbucks_consumption_type.ts
var StarbucksConsumptionType = /* @__PURE__ */ function(StarbucksConsumptionType) {
	StarbucksConsumptionType["InStore"] = "ConsumeInStore";
	StarbucksConsumptionType["OutOfStore"] = "ConsumeOutOfStore";
	return StarbucksConsumptionType;
}(StarbucksConsumptionType || {});
//#endregion
export { StarbucksConsumptionType };

//# sourceMappingURL=starbucks_consumption_type.js.map